// alert('hi');
const body = document.querySelector('body');


/*--------------------------------------
html
*/
const html = document.querySelector('html');
// html.classList.add('scroll');

/*--------------------------------------
model house （フォームをクリックした時の動きがキモいので）
*/
if (body.classList.contains('page-model-house')) {
  html.style.scrollBehavior = 'auto';
}

/*--------------------------------------
wide navかどうか？
*/
const navBreakPoint = 720;
let wideNav;

function navSize(ww) {
  //console.log('window width : ' + ww + ' break point : ' + navBreakPoint);
  if (ww < navBreakPoint) {
    wideNav = false;
    html.classList.remove('wide-nav');

  } else {
    wideNav = true;
    html.classList.add('wide-nav');
  }
  // alert('wideNav ? : ' + wideNav);
}


/*--------------------------------------
touch かどうか？
*/
let eventType;
function isTouch() {
  eventType = 'click';
  let touch_event = window.ontouchstart;
  let touch_points = navigator.maxTouchPoints;

  if (touch_event !== undefined && 0 < touch_points) {
    eventType = 'click';
  } else {
    html.classList.remove('sp');
    html.classList.add('pc');
  }
  //alert(eventType);
}
isTouch();

/*--------------------------------------
デバイスのresize判定
*/
let isOrientationChangeSupported = 'onorientationchange' in window;
let resizeEvent;
if (isOrientationChangeSupported) {
  resizeEvent = 'orientationchange';
} else {
  resizeEvent = 'resize';
}
//alert(resizeEvent);

/*--------------------------------------
 scrollbar width
 */
let ww = window.innerWidth;
document.addEventListener('DOMContentLoaded', function () {

  navSize(ww);

  // スクロールバーが表示されているかどうか
  function isScrollbar() {
    let scrollbarWidth = ww - document.documentElement.clientWidth;
    if (scrollbarWidth > 20) { scrollbarWidth = 20; }
    // console.log("Scrollbar visible:", scrollbarWidth);
    if (scrollbarWidth > 0) {
      body.style.setProperty("--scrollbarWidth", scrollbarWidth + 'px');
    }
  }
  isScrollbar();

  //スクリーンいっぱいの画像のsizes指定を変更
 //Safariでは効かない…じゃなくてバグらしい
  //https://bugs.webkit.org/show_bug.cgi?id=27684
  const fit_screen_imgs = document.querySelectorAll('.fit-screen img');
  // console.log(fit_screen_imgs.length);
  if (Math.max(ww, window.innerHeight) === window.innerHeight) {
    // console.log('縦長')
    if (fit_screen_imgs.length > 0) {
      Array.prototype.slice.call(fit_screen_imgs, 0).forEach((i) => {
        // console.log(i);
        i.setAttribute('sizes', Math.round(window.innerHeight * 1.5) + 'px');
      });
    }
  }

});


window.addEventListener('load', () => {

  html.classList.add('loaded');

  /*--------------------------------------
    global navの外部リンク
    スマホではそのまま
    */
  if (eventType === 'click') {
    const links = document.querySelectorAll('a[rel="external"]');
    links.forEach((link) => {
      link.setAttribute('target', '_blank');
    });
  }


  /*--------------------------------------
  global nav
  */
  const trigger = document.getElementById('trigger');
  const triggerText = document.getElementById('trigger-text');
  const modal = document.getElementById('site-nav');
  // const header = document.getElementById('site-header');
  const subMenuBtn = document.querySelectorAll('#site-nav .wp-block-navigation-submenu__toggle');
  const navContent = document.querySelector('.site__nav-content');

  modal.setAttribute('aria-hidden', 'true');


  function openMenu() {

    
    //menu-openにする
    modal.setAttribute('aria-hidden', 'false');
    //modalのaria-hiddenをfalseに
    triggerText.innerHTML = 'メニューを閉じる';
    //開閉ボタンのHTML変更
    
      //広いメニューの場合はすべてのサブメニューボタンのaria-expandedをtrueにする
      Array.from(subMenuBtn).forEach((btn) => {
        //console.log(btn);
        if (wideNav) { 
          btn.setAttribute('aria-expanded', 'true');
          btn.closest('.has-child').classList.add('submenu-open');
        }else{
          btn.setAttribute('aria-expanded', 'false');
          btn.closest('.has-child').classList.remove('submenu-open');
        }
      });
    
    //もしHTMLが「menu-open」じゃなかったら
    html.classList.add('menu-open');

  }

  function closeMenu() {

        //HTMLの「menu-open」トル
        html.classList.remove('menu-open');

    //サブメニューボタンのaria-expandedをfalseにする
    Array.from(subMenuBtn).forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
      //ボタンの親要素の.has-child(li)を閉じる（広いメニューでも）
      btn.closest('.has-child').classList.remove('submenu-open');
    });
    //開閉ボタンのHTMLを変更
    triggerText.innerHTML = 'メニューを開く';
    //modalのaria-hiddenをtrueにする（隠す）
    modal.setAttribute('aria-hidden', 'true');


    navContent.scrollTop = 0;
  }

  trigger.addEventListener(eventType, (e) => {
    // 開閉ボタンが押されたら
    e.stopPropagation();
    if (!html.classList.contains('menu-open')) {
      openMenu();
    } else {
      closeMenu();
    }
  }, { passive: true });

  /*--------------------------------------
  submenu開閉
  */

  function submenuStatus(e) {

    //ボタンが押されたら
    e.stopPropagation();
    //デフォの動作を止める
    if (e.target.tagName.toLowerCase() === 'button') {
      //押されたのがボタンだったら
      let parent = e.target.closest('.has-child');
      //ボタンの親要素.has_childを取得（li)
      if (parent) {
        //親要素があったら
        if (!parent.classList.contains('submenu-open')) {
          //親要素が「submenu-open」じゃなかったら
          e.target.setAttribute('aria-expanded', 'true');
          //ボタンのaria-expandedをtrueに
          let submenus = document.querySelectorAll('.submenu-open');
          //現在開いているsubmenuを取得
          if (submenus) {
            //開いているサブメニューがあれば
            Array.from(submenus).forEach((sub) => {
              // console.log(sub.innerHTML);
              // console.log(parent.innerHTML);
              if (sub.innerHTML !== parent.innerHTML) {
                //今クリックされた要素（ボタン）の親と一致しなければ閉じる
                sub.classList.remove('submenu-open');
                sub.querySelector('.wp-block-navigation-submenu__toggle').setAttribute('aria-expanded', 'false');
              }
            });
          }
          //親要素に「submenu-open」クラス
          parent.classList.add('submenu-open');

        } else {
          //親要素が「submenu-open」だったら（開いていたら）
          e.target.setAttribute('aria-expanded', 'false');
          parent.classList.remove('submenu-open');
        }
      }
    }

  }


  Array.from(subMenuBtn).forEach((btn) => {
    btn.addEventListener(eventType, submenuStatus, { passive: true })
  });


  /*--------------------------------------
 modal
 */
  modal.addEventListener(eventType, (e) => {
    //メニュー部分以外をクリックしたら閉じる
    if (wideNav) {
      e.stopPropagation();
      if (html.classList.contains('menu-open')) {
        if (!e.target.closest('#site-nav-content')) {
          closeMenu();
        }
      }
    }
  }, { passive: true });

  /*--------------------------------------
  year: 創業
  PHPで対応した
  */
  // const established = 1974;

  // const year = document.querySelectorAll('.pastyear');
  // const now = new Date().getFullYear();
  // const since_founding = now - established;

  // year.forEach((y) => {
  //   y.innerHTML = since_founding;
  // });



  /*--------------------------------------
  wordpressはdivをaで囲めないので…
  */

  if (body.classList.contains('page-parent')) {
    const childLinks = document.querySelectorAll('.page__parent-link');
    Array.from(childLinks).forEach((link) => {
      let linkItem = link.getElementsByTagName('h3')[0].getElementsByTagName('a')[0];
      let linkurl = linkItem.getAttribute('href');
      let linkTitle = linkItem.innerHTML;
      let linkBody = link.getElementsByTagName('p')[0].innerHTML
      let newHTML = '<a class="parent-link" href="' + linkurl + '"><h3 class="serif">' + linkTitle + '</h3><p>' + linkBody + '</p></a>';
      link.innerHTML = newHTML;
    });

  }

  /*--------------------------------------
  page topをスクロールで表示
  */
  const pageTop = document.getElementById('pagetop');
  const pageTopObserver = document.getElementById('observer-pagetop');

  if (pageTopObserver && pageTop) {
    const pageTopOptions = {
      threshold: 0,
    };
    const pageobserver = new IntersectionObserver(togglePageTop, pageTopOptions);
    pageobserver.observe(pageTopObserver);

    function togglePageTop(entries) {
      if (entries[0].isIntersecting) {
        pageTop.classList.remove('show');
      } else {
        pageTop.classList.add('show');
      }
    }
  }

  /*--------------------------------------
  page topの動作
  */
  let pageTopTimer;
  if (pageTop) {
    pageTop.addEventListener(eventType, (e) => {
      e.preventDefault();
      let currentBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = "smooth";


      if (pageTopTimer) clearTimeout(pageTopTimer);

      pageTopTimer = setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          bahaviour: "smooth"
        });
        html.style.scrollBehavior = currentBehavior;
        setTimeout(() => {
          //console.log('RESIZE END');
          clearTimeout(pageTopTimer);
        }, 900);
      }, 100);
    }, { passive: false });
  }

  /*--------------------------------------
 footerに到達したときの global "menu"文字色
 resizeで変更（footer、window Height)
 */
  const footer = document.getElementById('site-footer');
  const devline = document.getElementById('observer');
  let screenH = window.innerHeight;
  let footerH;
  let footerBeforeHeight;

  function toggleNavColor(entries) {
    if (footerH > screenH) {
      if (entries[0].isIntersecting) {
        html.classList.add('page-bottom');
      } else {
        html.classList.remove('page-bottom');
      }
    } else {
      html.classList.remove('page-bottom');
    }
  };

  function calcFooterBeforeHeight(ww) {
    if (ww >= 1280) {
      //css $bp-xl
      return Math.round(((ww * 0.8) / 35) * 3.75);
    } else {
      if (ww < 720) {
        //css $bp-m
        return Math.round(((ww * 0.9) / 35) * 3.75);
      } else {
        //under $bp-m
        return Math.round(((ww - 32) / 35) * 3.75);
      }
    }
  };


  function isBottom(entries) {
    if (entries[0].isIntersecting) {
      html.classList.add('page-end');
    } else {
      html.classList.remove('page-end');
    }
  }

  if (footer) {
    footerH = footer.clientHeight;
    footerBeforeHeight = calcFooterBeforeHeight(ww);
    const options = {
      threshold: 0
    };
    const observer = new IntersectionObserver(toggleNavColor, options);
    observer.observe(devline);
    //背景固定画像を、ページ一番下まで来た時に隠す & htmlの背景色変更
    const footer_options = {
      threshold: 1
    };
    const footer_observer = new IntersectionObserver(isBottom, options);
    footer_observer.observe(footer);

    if (pageTop) {
      /*--------------------------------------
      page topがfooterに到達した際に色を変える
      */
      const pageTopFooterOptions = {
        rootMargin: '0px 0px ' + Math.round((pageTop.clientHeight / 2) + footerBeforeHeight) * -1 + 'px 0px',
      };
      const pageFooterObserver = new IntersectionObserver(togglePageTopColor, pageTopFooterOptions);
      pageFooterObserver.observe(footer);

      function togglePageTopColor(entries) {
        if (entries[0].isIntersecting) {
          pageTop.classList.add('page-bottom');
        } else {
          pageTop.classList.remove('page-bottom');
        }
      };
    }
  }






  /*--------------------------------------
  fade in
  */

  const targets = document.getElementsByClassName('fade');
  if (targets) {
    const fadeOptions = {
      rootMargin: '0px 0px -200px 0px'
    }
    for (let i = targets.length; i--;) {
      let fadeObserver = new IntersectionObserver((entries) => {
        for (let j = entries.length; j--;) {
          if (entries[j].isIntersecting) {
            if (!entries[j].target.classList.contains('active')) {
              entries[j].target.classList.add('active');
            }

          }
        }
      }, fadeOptions);
      fadeObserver.observe(targets[i]);
    }
  }

  if (body.classList.contains('single-post') || body.classList.contains('single-land')) {
    const lightbox_images = document.querySelectorAll('.wp-block-gallery a');
    Array.from(lightbox_images).forEach((img) => {
      img.setAttribute('data-fancybox', 'gallerygroup');
    })
  }

  let maptimer;
  if (html.classList.contains('pc')) {
    const maps = document.querySelectorAll('.googlemap');

    if(body.classList.contains('single-land')){
      maptimer = setTimeout(() => {
        html.classList.add('ready');
        setTimeout(() => {
          clearTimeout(maptimer);
        }, 200);
      }, 500);
    }

    if (maps) {
      Array.from(maps).forEach((map) => {

        map.addEventListener('click', (e) => {
          map.classList.add('map-in')
        });
        map.addEventListener('mouseleave', (e) => {
          map.classList.remove('map-in')
        });
      });
    }
  }

  /*--------------------------------------
  .dev mode
  */
  function getUrlQueries() {
    const queryStr = window.location.search.slice(1);  // 文頭?を除外
    queries = {};

    // クエリがない場合は空のオブジェクトを返す
    if (!queryStr) {
      return queries;
    }

    // クエリ文字列を & で分割して処理
    queryStr.split('&').forEach(function (queryStr) {
      // = で分割してkey,valueをオブジェクトに格納
      const queryArr = queryStr.split('=');
      queries[queryArr[0]] = queryArr[1];
    });

    return queries;
  }
  queries = getUrlQueries();
  // console.log(queries);
  // console.log(Object.entries(queries));
  if (queries) {
    for (const [key, value] of Object.entries(queries)) {
      // console.log(`${key}: ${value}`);
      if (key === 'mode' && value === 'nichiei__dev_mode') {
        let createElement = '<div id="dev"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>'
        body.insertAdjacentHTML('beforeend', createElement);
      }
    }
  }


  let timer;
  window.addEventListener(resizeEvent, () => {
   
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      
      ww = window.innerWidth;
      if(html.classList.contains('menu-open')){
        closeMenu();
      }
     
      // console.log('RESIZED');
      navSize(ww);
      if (footer) {
        footerH = footer.clientHeight;
        screenH = ww;
        footerBeforeHeight = calcFooterBeforeHeight(ww);
      }
      setTimeout(() => {
        //console.log('RESIZE END');
        clearTimeout(timer);
      }, 1201);
    }, 400);
  });

})

